import { catalog } from "@/mocks/homeData";

export default function Catalog() {
  return (
    <section id="catalog" className="border-y border-ink/10 bg-paper/60">
      <div className="shell-wrap py-14 md:py-20">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="section-eyebrow">
              <i className="ri-folder-5-fill" /> 分类导览
            </p>
            <h2 className="title-serif mt-2 text-2xl font-black md:text-4xl">
              从四个入口进入 91黑料
            </h2>
          </div>
          <a
            href="#collections"
            className="inline-flex items-center gap-1.5 rounded-full border border-ink/15 bg-paper px-4 py-2 text-sm font-semibold transition-colors hover:border-ember hover:text-ember cursor-pointer"
          >
            去合集大全 <i className="ri-arrow-down-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {catalog.map((c) => (
            <a
              key={c.key}
              href="#collections"
              className="group card-lift relative flex flex-col rounded-2xl border border-ink/10 bg-paper p-5 md:p-6"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-ember text-xl text-white">
                <i className={c.icon} />
              </span>
              <h3 className="title-serif mt-4 text-lg font-black">
                {c.name}
                <span className="ml-2 align-middle text-xs font-normal text-ink/45">{c.count}</span>
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-ink/65">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-bold text-ember">
                进入分类
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}